import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import Modal from "../../components/Modal";
import { IoMdClose } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import SidePanel from "../../components/SidePanel";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../../components/Spinner";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { MdChevronLeft, MdChevronRight } from "react-icons/md"; // Importing react-icons
import thirdLogo from "../../assets/icons/newBackCover.png";
import { IoReload } from "react-icons/io5";
import { IoMdPrint } from "react-icons/io";
import { CiBookmarkCheck } from "react-icons/ci";
import { toast } from "react-toastify";
import {
  handleErrorResponse,
  handleSuccessResponse,
} from "../../utils/PickCards";
import moment from "moment/moment";
import { getAdjustedEventDate } from "../../utils/sendToPrint";
import useIsMobile from "../../hooks/useMobile";

const PickCard = () => {
  const [loader, setLoader] = useState(false);
  const [occasions, setOccasions] = useState([]);
  const token = useMemo(() => localStorage.getItem("token"), []);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [recipientID, setRecipientID] = useState("");
  const [relationship, setRelationship] = useState("");
  const [occasion, setOccasion] = useState("");
  const [eventId, setEventId] = useState("");
  const [birthday, setBirthday] = useState("");
  const [gender, setGender] = useState("");
  const [character_traits, setCharacter_traits] = useState([]);
  const [messageTheme, setMessageTheme] = useState([]);
  const [cards, setCards] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);
  const [eventOfRecipientId, setEventOfRecipientId] = useState("");
  const [fromNavigatedPageName, setFromNavigatedPageName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [isModalOpen, setIsModelOpen] = useState(false);
  const [isActivityModelOpen, setIsActivityModelOpen] = useState(false);
  const [element, setElement] = useState(null);
  const toggleModal = () => {
    setIsModelOpen(!isModalOpen);
  };

  const newToggleModal = () => {
    setIsActivityModelOpen(!isActivityModelOpen);
  };

  const [currentSlide, setCurrentSlide] = useState(0);
  const [customerCards, setCustomerCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState("");
  const [selectedCardID, setSelectedCardID] = useState(null);

  const swiperRef = useRef(null);
  const carouselRef = useRef(null);
  const thumbnailsRef = useRef(null);

  const textAreaRef = useRef();
  const greetingsRef = useRef();
  const signoffRef = useRef();

  const [textGenerationLoader, setTextGenerationLoader] = useState(false);
  const [Normal1Paragraph, setNormal1Paragraph] = useState("");
  const [Normal2Paragraphs, setNormal2Paragraphs] = useState("");
  const [Poem, setPoem] = useState("");
  const [ShortAndSweet, setShortAndSweet] = useState("");
  const [font, setFont] = useState("23px");
  const [greetings, setGreetings] = useState("");
  const [signoff, setSignoff] = useState("");
  const [text, setText] = useState("");
  const [hideCards, setHideCards] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [printLoader, setPrintLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const monthOrder = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const fontSize = [
    "text-[1em]",
    "text-[1.2em]",
    "text-[1.4em]",
    "text-[1.6em]",
    "text-[1.8em]",
    "text-[2em]",
    "text-[2.2em]",
  ];

  const signoffsList = [
    "Yours Sincerely",
    "Yours Truly",
    "Lots of Love",
    "Hugs and Kisses",
    "Warm Wishes",
    "All of Love",
    "All the Best",
  ];

  const randomSignoff =
    signoffsList[Math.floor(Math.random() * signoffsList.length)];

  const fetchAIText = async () => {
    setTextGenerationLoader(true);

    if (token) {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/generate-AI-message`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
          body: JSON.stringify({
            name,
            relationship,
            occasion,
            birthday,
            gender,
            character_traits,
            message_theme: messageTheme,
          }),
        }
      );
      const data = await res.json();
      setTextGenerationLoader(false);
      if (data.code === 200) {
        setNormal1Paragraph(data.data.Normal1Paragraph);
        setNormal2Paragraphs(data.data.Normal2Paragraphs);
        setPoem(data.data.Poem);
        setShortAndSweet(data.data.ShortAndSweet);
      }
    }
  };

  const autoAdjustHeight = (e) => {
    if (e && e?.target) {
      e.target.style.height = "auto";

      e.target.style.height = `${e.target.scrollHeight}px`;
    }
  };

  const [isChanged, setIsChanged] = useState(false);

  const isMobile = useIsMobile();

  const adjustFontSize = (length, height) => {
    if (isMobile) {
      if (length <= 100 && font !== "13px") {
        setFont("13px");
      } else if (length > 100 && length <= 180) {
        setFont("12px");
      } else if (length > 180 && length <= 240) {
        setFont("11px");
      } else if (length > 240) {
        setFont("10px");
      }
      return;
    } else if (isMobile && isChanged) {
      return;
    }

    if (length <= 200 && font !== "23px") {
      setFont("23px");
    } else if (length > 200 && length <= 364) {
      setFont("21px");
    } else if (length > 365 && length <= 599) {
      setFont("19px");
    } else if (length > 600 && length <= 774) {
      setFont("18px");
    } else if (length > 775 && length <= 944) {
      setFont("16px");
    } else if (length > 945 && length <= 1049) {
      setFont("15px");
    } else if (length > 1050) {
      setFont("14px");
    }
  };

  const incrementFontSize = () => {
    // Convert the current font size to a number, increment, and add "px" back

    if (isMobile && !isChanged) {
      setIsChanged(true);
    }

    const validFont = isMobile ? 13 : 25;

    const currentFont = parseInt(font); // Convert to number
    if (currentFont < validFont) {
      setFont(`${currentFont + 1}px`);
    }
  };

  const decrementFontSize = () => {
    if (isMobile && !isChanged) {
      setIsChanged(true);
    }

    const validFont = isMobile ? 9 : 18;

    // Convert the current font size to a number, decrement, and add "px" back
    const currentFont = parseInt(font); // Convert to number
    if (currentFont > validFont) {
      setFont(`${currentFont - 1}px`);
    }
  };

  const handleInputChange = (e, setState, ref) => {
    setState(e.target.value);
    if (ref.current?.name === "message") {
      adjustFontSize(e.target.value?.length, e);

      autoAdjustHeight(e);
      setElement({ e });
    }
  };
  useEffect(() => {
    let id;
    if (element?.e) {
      id = setTimeout(() => {
        autoAdjustHeight(element?.e);
      }, 300);
    }
    return () => clearTimeout(id);
  }, [font, element]);
  const groupCardsByYearAndMonth = useCallback((cards, occasions) => {
    return cards.reduce((grouped, card) => {
      const eventObject = occasions?.find((el) => el._id === card.eventId);
      const adjustedEventDate = getAdjustedEventDate(
        card.eventDate,
        card.createdAt,
        eventObject,
        card
      );

      const year = adjustedEventDate.getFullYear();
      const month = adjustedEventDate.toLocaleString("default", {
        month: "long",
      });

      if (!grouped[year]) {
        grouped[year] = {};
      }

      if (!grouped[year][month]) {
        grouped[year][month] = [];
      }

      grouped[year][month].push(card);

      return grouped;
    }, {});
  }, []);

  const handleSubmit = async (status) => {
    if (status === "draft") {
      setSaveLoader(true);
    } else {
      setPrintLoader(true);
    }
    const token = localStorage.getItem("token");
    const customerId = localStorage.getItem("ID");
    if (!text) {
      toast.error("Please enter a message");
      setSaveLoader(false);
      setPrintLoader(false);
      return;
    }
    if (!recipientID) {
      toast.error("Please go back and select a recipient first");
      setSaveLoader(false);
      setPrintLoader(false);
      return;
    }
    if (!occasion || !eventId) {
      toast.error("Please go back and select an occasion first");
      setSaveLoader(false);
      setPrintLoader(false);
      return;
    }
    console.log("selectedCardID", selectedCardID);
    if (selectedCardID == null || selectedCardID == "undefined") {
      // Catches both null and undefined
      toast.error("Please select a card first");
      setSaveLoader(false);
      setPrintLoader(false);
      return;
    }
    if (!messageTheme) {
      toast.error("Please go back and select a message theme to proceed");
      setSaveLoader(false);
      setPrintLoader(false);
      return;
    }
    const payload = {
      receiptsId: recipientID,
      customerId,
      textCard: text,
      cardId: selectedCardID,
      messageTheme,
      isBirthday: occasion === "Birthday",
      isAnniversary: occasion === "Anniversary",
      eventId: eventId,
      textTo: greetings,
      textFrom: signoff,
      status,
    };
    const endpoint =
      eventOfRecipientId && eventOfRecipientId.trim() !== ""
        ? `/api/eventOfRecipient/edit-event-recipient/${eventOfRecipientId}`
        : `/api/eventOfRecipient/create-event-recipient`;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      setSaveLoader(false);
      setPrintLoader(false);
      if (data.code === 200) {
        handleSuccessResponse(status, eventOfRecipientId, toast, navigate);
      } else {
        handleErrorResponse(data, toast, navigate);
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    let updatedFilteredCards = cards;
    if (occasion) {
      updatedFilteredCards = updatedFilteredCards.filter((card) =>
        card.categories.some(
          (category) => category.name.toLowerCase() === occasion.toLowerCase()
        )
      );
    }
    if (gender) {
      updatedFilteredCards = updatedFilteredCards.filter((card) =>
        card.tags.some((tag) => tag.name.toLowerCase() === gender.toLowerCase())
      );
    }
    setFilteredCards(updatedFilteredCards);
  }, [occasion, gender, cards]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchCards = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/card/get-cards`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      setCards(data.data);
    };
    if (token) {
      fetchCards();
    }
  }, []);
  const fetchCustomer = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/get-customer-cards`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        }
      );
      const data = await res.json();
      setCustomerCards(data?.data);
    } catch (error) {
      toast.error("Failed to fetch cards.");
    }
  };
  useEffect(() => {
    fetchCustomer();
  }, []);
  useEffect(() => {
    const fetchOccasions = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const res = await response.json();
        if (res.code === 200) {
          setOccasions(res.data);
        }
      } catch (error) {
        toast.error("Failed to fetch occasions.");
      }
    };
    fetchOccasions();
  }, [token]);

  useEffect(() => {
    if (textAreaRef.current) {
      autoAdjustHeight(textAreaRef);
      autoAdjustHeight(greetingsRef);
      autoAdjustHeight(signoffRef);
    }
  }, [text, greetings, signoff, font]);

  useEffect(() => {
    const fetchAIText = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/generate-AI-message`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
            body: JSON.stringify({
              name,
              relationship,
              occasion,
              birthday,
              gender,
              character_traits,
              message_theme: messageTheme,
            }),
          }
        );
        const data = await res.json();
        setTextGenerationLoader(false);
        if (data.code === 200) {
          setNormal1Paragraph(data.data.Normal1Paragraph);
          setNormal2Paragraphs(data.data.Normal2Paragraphs);
          setPoem(data.data.Poem);
          setShortAndSweet(data.data.ShortAndSweet);
        }
      }
    };
    if (
      name &&
      relationship &&
      occasion &&
      birthday &&
      gender &&
      character_traits &&
      messageTheme
    ) {
      fetchAIText();
    }
  }, [
    name,
    relationship,
    occasion,
    birthday,
    gender,
    character_traits,
    messageTheme,
  ]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const name = urlParams.get("name");
    const recipientID = urlParams.get("recipientID");

    const relationship = urlParams.get("relationship");
    const occasion = urlParams.get("occasion");
    const eventId = urlParams.get("eventId");
    const birthday = urlParams.get("birthday");
    const gender = urlParams.get("gender");
    const characterTraits = urlParams.get("character_traits");
    const messageTheme = urlParams.get("messageTheme");
    const me = urlParams.get("me");
    const thumbnail = urlParams.get("thumbnail");
    console.log("thumbnail: ", thumbnail);
    const cardID = urlParams.get("selectedCardID");
    const EventOfRecipientId = urlParams.get("eventOfRecipientId");
    const FromNavigatedPageName = urlParams.get("fromNavigatedPageName");
    const page = urlParams.get("page");
    const incomingEventDate = urlParams.get("eventDate");

    if (me) {
      setSignoff(randomSignoff + ", \n" + me);
    }

    if (name) {
      setName(name);
    }
    if (incomingEventDate) {
      setEventDate(incomingEventDate);
    }
    if (recipientID) {
      setRecipientID(recipientID);
    }
    if (relationship) {
      setRelationship(relationship);
      setGreetings("Dear " + relationship + ",\n");
    }
    if (occasion) {
      setOccasion(occasion);
    }
    if (eventId) {
      setEventId(eventId);
    }
    if (birthday) {
      setBirthday(birthday);
    }
    if (gender) {
      setGender(gender);
    }
    if (thumbnail) {
      setSelectedCard(thumbnail);
      setHideCards(true);
    }
    if (cardID) {
      setSelectedCardID(cardID);
    }
    if (characterTraits) {
      const CRT = characterTraits.includes(",")
        ? characterTraits.split(",")
        : [characterTraits];
      setCharacter_traits(CRT);
    }
    if (messageTheme) {
      const themes = messageTheme.includes(",")
        ? messageTheme.split(",")
        : [messageTheme];
      setMessageTheme(themes);
    }
    if (EventOfRecipientId) {
      setEventOfRecipientId(EventOfRecipientId);
    }
    if (FromNavigatedPageName) {
      setFromNavigatedPageName(FromNavigatedPageName);
    }
    if (page === "3") {
      setCurrentSlide(1); // Assuming the slides are 0-indexed, and the 3rd page is at index 2
    }

    if (greetings) {
      setGreetings(greetings);
    }
    if (signoff) {
      setSignoff(signoff);
    }
  }, []);

  useEffect(() => {
    if (!text) return;

    // Scroll carousel
    carouselRef.current?.scrollIntoView({ behavior: "smooth" });

    if (currentSlide !== 1) {
      setCurrentSlide(1);
    }

    // ✅ ONLY DESKTOP SHOULD FOCUS
    if (!isMobile && textAreaRef.current) {
      textAreaRef.current.focus({ preventScroll: true });
      textAreaRef.current.value = text;

      const syntheticEvent = {
        target: textAreaRef.current,
      };

      handleInputChange(syntheticEvent, setText, textAreaRef);
    }

    // ✅ MOBILE: explicitly blur
    if (isMobile && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }, [text, isMobile]);

  useEffect(() => {
    if (isMobile) {
      adjustFontSize(1);
    }
  }, [isMobile]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const greetings = urlParams.get("greetings");
    const signoff = urlParams.get("signoff");
    const text = urlParams.get("text");

    if (greetings) {
      setGreetings(greetings);
    }
    if (signoff) {
      setSignoff(signoff);
    }
    if (text) {
      setText(text);
    }
  }, []);

  useEffect(() => {
    autoAdjustHeight(greetingsRef);
    autoAdjustHeight(textAreaRef);
    autoAdjustHeight(signoffRef);
    adjustFontSize();
  }, [text, greetings, signoff]);

  const isMultilineText = (text) => {
    return text.split("\n").length > 3;
  };

  const getTextAlignmentClass = (text) => {
    return isMultilineText(text) ? "text-center" : "text-left";
  };

  if (loader) {
    return (
      <section className="flex">
        <SidePanel />
        <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
          <div className="h-screen w-full flex items-center justify-center border-[3px] border-gray-500 border-dashed rounded-md sm:p-10 p-5 sm:m-10 m-5">
            <Spinner
              props={"Please wait while we are generating your card"}
              size={"130px"}
            />
          </div>
        </div>
      </section>
    );
  }

  return (
    // <section className="flex max-w-[1200px] mx-auto">
    <section className="flex mx-auto px-4 sm:px-2">
      <SidePanel />
      <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4 overflow-hidden">
        <div className="flex flex-col items-start justify-center md:flex-row md:justify-between">
          <div className="w-full p-4 md:p-0">
            <h3 className="text-lg md:text-xl font-medium mb-4 text-center md:text-left">
              <Link to="/dashboard/card_generation" className="hover:underline">
                Card Generation
              </Link>
              {" > "} <span className="text-primary">Pick Card</span>
            </h3>
            <div className={`${hideCards && ""}`}>
              <div className="relative">
                <div className="absolute top-1/2 left-0 transform z-40 -translate-y-1/2">
                  <button
                    onClick={() => (thumbnailsRef.current.scrollLeft -= 160)}
                    className="p-2 rounded-full shadow-md  bg-primary text-white z-40 w-10 h-10 hover:bg-primary-dark"
                  >
                    <MdChevronLeft size={25} />
                  </button>
                </div>
                <div className="absolute top-1/2 right-0 z-40 transform -translate-y-1/2">
                  <button
                    onClick={() => (thumbnailsRef.current.scrollLeft += 160)}
                    className="p-2 rounded-full shadow-md  bg-primary text-white  w-10 h-10 hover:bg-primary-dark"
                  >
                    <MdChevronRight size={25} />
                  </button>
                </div>
                <div
                  ref={thumbnailsRef}
                  className="flex gap-5 overflow-x-auto rounded-xl px-10 bg-gray-100"
                  style={{ scrollBehavior: "smooth" }}
                >
                  {filteredCards?.length === 0 ? (
                    <div className="w-full text-xl text-center text-primary">
                      No cards available yet for {occasion}
                    </div>
                  ) : (
                    filteredCards?.map((card, index) => {
                      const decodedThumbnail = decodeURIComponent(
                        card.thumbnail
                      );
                      //
                      return (
                        <div
                          onClick={() => {
                            setSelectedCard(decodedThumbnail);
                            if (card?._id) {
                              setSelectedCardID(card?._id);
                            }
                            if (carouselRef?.current) {
                              carouselRef?.current.scrollIntoView({
                                behavior: "smooth",
                              });
                            }
                            setCurrentSlide(0);
                          }}
                          className={`relative my-5  flex-shrink-0 z-20 rounded-md cursor-pointer ${
                            selectedCard === decodedThumbnail
                              ? "border border-primary shadow-md"
                              : "border-transparent hover:border hover:border-primary"
                          } hover:shadow-md transition duration-300 ease-in-out`}
                          key={index}
                          style={{ width: "150px", height: "224px" }} // Thumbnail size
                        >
                          {/* {selectedCard === card?.thumbnail && (
                          <div className="absolute inset-y-0 right-3 top-2">
                            <IoCheckmarkCircleOutline className="text-3xl text-primary" />
                          </div>
                        )} */}

                          <img
                            src={card?.thumbnail}
                            alt="Card Thumbnail"
                            className="rounded-md w-full h-full object-cover"
                          />
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
              <hr className="my-4 border-primary" />
            </div>
          </div>
        </div>
        <div
          className={`${
            !selectedCard && "blur-md pointer-events-none"
          } flex flex-col items-center justify-center gap-12 mt-10 md:flex-row md:items-start md:mt-20 md:pr-3 w-full pb-24`}
        >
          <div className=" w-[85%] lg:w-[45%] relative flex items-left justify-left mb-4">
            <div className="relative w-full max-w-[480px] lg:h-[672px] mx-auto">
              <div className="text-end">
                Font Size :
                <div className="inline-flex gap-2 border-2 ml-1 border-primary rounded px-1 w-24 mb-1 items-center">
                  <button
                    className="border-0 bg-transparent text-primary text-3xl font-bold w-8"
                    onClick={decrementFontSize}
                  >
                    -
                  </button>
                  <span className="text-center flex-1">{font}</span>
                  <button
                    className="border-0 bg-transparent text-primary text-3xl font-bold w-8"
                    onClick={incrementFontSize}
                  >
                    +
                  </button>
                </div>
              </div>

              <Carousel
                showThumbs={false} // Removes the thumbnail navigation dots
                showArrows={false} // Removes the internal arrow buttons
                showIndicators={false} // Removes the main navigation dots (indicator)
                showStatus={false} // Hides the current slide status (e.g., 1/3)
                swipeable={false}
                emulateTouch={false}
                selectedItem={currentSlide}
                onChange={setCurrentSlide}
                style={{ width: "100%", height: "672px" }} // Set consistent width and height for the carousel
              >
                {selectedCard !== "" ? (
                  <div
                    className="border-2 rounded-sm border-primary  md:h-[672px]"
                    style={{ width: "100%" }} // Ensure each slide has the same size
                  >
                    <img
                      src={selectedCard}
                      alt="Card Thumbnail"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : (
                  <div
                    className="md:h-[672px] flex flex-col items-center justify-center bg-white border-2 rounded-sm border-primary"
                    style={{ width: "100%" }} // Ensure each slide has the same size
                  >
                    <h1 className="text-5xl font-bold text-gray-300">
                      Select A Card
                    </h1>
                  </div>
                )}

                <div
                  className="h-full lg:h-[672px]"
                  style={{ width: "100%" }} // Set consistent height and width
                >
                  <div
                    className="relative flex flex-col items-center justify-center h-full w-full border-2 rounded-sm border-primary bg-white bg-none group"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <div className="w-full px-10 max-sm:px-7 text-blue-800">
                      <p className="w-full text-lg text-left duration-300 ease-in-out opacity-0 text-primary group-hover:opacity-100">
                        Greetingss
                      </p>

                      {/* Greeting Textarea (Fixed Height) */}
                      <textarea
                        ref={greetingsRef}
                        style={{
                          fontSize: font,
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                        className={`card_inside px-3 py-4 bg-transparent overflow-hidden resize-none w-full text-left border-2 border-gray-50 h-[63px] group-hover:border-primary group-hover:border-opacity-80 duration-300 ease-in-out focus:border-2 focus:border-primary rounded-lg`}
                        value={greetings}
                        onChange={(e) => {
                          if (
                            e.target.value.length <= 100 &&
                            e.target.scrollHeight <= 66
                          ) {
                            handleInputChange(e, setGreetings, greetingsRef);
                          }
                        }}
                        maxLength={100}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            (e.target.value?.length >= 100 ||
                              e.target.scrollHeight >= 66)
                          ) {
                            handleInputChange(e, setGreetings, greetingsRef);
                          }
                        }}
                      />

                      {/* Message Text */}
                      <p
                        className={`text-primary text-lg w-full opacity-0 group-hover:opacity-100 duration-300 ease-in-out text-left`}
                      >
                        Message
                      </p>

                      {/* Message Textarea (Auto-adjusting Height) */}
                      <textarea
                        ref={textAreaRef}
                        style={{ fontSize: font }}
                        name="message"
                        className={`card_inside px-3 py-2 bg-transparent overflow-hidden resize-none w-full leading-tight min-h-[150px] max-md:!h-[150px] max-h-[390px] border-2 border-gray-50 group-hover:border-primary group-hover:border-opacity-80 duration-300 ease-in-out focus:border-2 focus:border-primary rounded-lg ${getTextAlignmentClass(
                          text
                        )}`}
                        value={text}
                        onChange={(e) => {
                          const updatedText = e.target.value;
                          if (
                            updatedText.length <= 1100 &&
                            e.target.scrollHeight <= 390
                          ) {
                            // if (selectedTemplate === "Normal1Paragraph") Normal1Paragraph = updatedText;
                            handleInputChange(e, setText, textAreaRef);
                          }
                        }}
                        maxLength={1100}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            (e.target.value?.length >= 1100 ||
                              e.target.scrollHeight >= 390)
                          ) {
                            handleInputChange(e, setText, textAreaRef);
                          }
                        }}
                      />

                      <p className="w-full text-lg text-left duration-300 ease-in-out opacity-0 text-primary group-hover:opacity-100">
                        Signoff
                      </p>

                      {/* Signoff Textarea (Fixed Height) */}
                      <textarea
                        ref={signoffRef}
                        style={{ fontSize: font }}
                        className={`card_inside px-3 py-4 bg-transparent overflow-hidden resize-none w-full text-right border-2 border-gray-50 group-hover:border-primary group-hover:border-opacity-80 duration-300 ease-in-out focus:border-2 focus:border-primary rounded-lg`}
                        value={signoff}
                        onChange={(e) => {
                          if (
                            e.target.value.length <= 100 &&
                            e.target.scrollHeight <= 100
                          ) {
                            handleInputChange(e, setSignoff, signoffRef);
                          }
                        }}
                        maxLength={100}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            (e.target.value?.length >= 100 ||
                              e.target.scrollHeight >= 100)
                          ) {
                            handleInputChange(e, setSignoff, signoffRef);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="border-2 rounded-sm border-primary md:h-[672px]"
                  style={{ width: "100%" }} // Ensure each slide has the same size
                >
                  <img
                    src={thirdLogo}
                    alt="ToBre logo"
                    className="w-full h-full object-cover"
                  />
                </div>
              </Carousel>

              <button
                type="button"
                onClick={() =>
                  setCurrentSlide((prev) => (prev > 0 ? prev - 1 : 1))
                }
                className="absolute top-1/2 left-[-40px] transform -translate-y-1/2 bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center z-10"
                aria-label="Previous Slide"
              >
                <MdChevronLeft size={24} /> {/* react-icon for Left Arrow */}
              </button>
              <button
                type="button"
                onClick={() =>
                  setCurrentSlide((prev) => (prev < 2 ? prev + 1 : 0))
                }
                className="absolute top-1/2 right-[-40px] transform -translate-y-1/2 bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center z-10"
                aria-label="Next Slide"
              >
                <MdChevronRight size={24} />
              </button>
            </div>
          </div>
          <div className="lg:w-[45%] flex flex-col gap-4">
            {textGenerationLoader ||
            !Normal1Paragraph ||
            !Normal2Paragraphs ||
            !Poem ||
            !ShortAndSweet ? (
              <div className="w-full flex items-center justify-center">
                <Spinner
                  props={"Generating AI Messages. Please Be Patient."}
                  size={"100px"}
                />
              </div>
            ) : (
              <>
                {textGenerationLoader ? (
                  <div className="h-screen w-full flex items-center justify-center border-[3px] border-gray-500 border-dashed rounded-md sm:p-10 p-5 sm:m-10 m-5">
                    <Spinner
                      props={"Please wait while we are generating your card"}
                      size={"130px"}
                    />
                  </div>
                ) : (
                  <>
                    <div className="flex flex-col gap-4">
                      <p
                        onClick={() => {
                          // Set the text only if it's different
                          if (text !== Normal1Paragraph) {
                            setSelectedTemplate("Normal1Paragraph");
                            setText(Normal1Paragraph);
                          }

                          // Scroll the slider into view
                          if (carouselRef.current) {
                            carouselRef.current.scrollIntoView({
                              behavior: "smooth",
                            });
                          }

                          // Update the current slide
                          if (currentSlide !== 1) {
                            setCurrentSlide(1);
                          }

                          // Programmatically focus the textarea without scrolling
                          if (textAreaRef.current) {
                            // textAreaRef.current.focus({ preventScroll: true });
                            if (!isMobile && textAreaRef.current) {
                              textAreaRef.current.focus({
                                preventScroll: true,
                              });
                            }
                            textAreaRef.current.value = Normal1Paragraph;

                            const syntheticEvent = {
                              target: textAreaRef.current, // Mimic the textarea's event structure
                            };

                            handleInputChange(
                              syntheticEvent,
                              setText,
                              textAreaRef
                            );
                          }
                        }}
                        className={`"p-4 h-24 border-2 rounded-md shadow-md cursor-pointer shadow-primary-light
                     hover:text-primary border-primary overflow-y-auto whitespace-pre-line
                     ${
                       selectedTemplate === "Normal1Paragraph"
                         ? "text-red-600 p-4 bg-cyan-400"
                         : "bg-white border-primary p-4"
                     }`}
                      >
                        {/* {Normal1Paragraph} */}
                        {selectedTemplate === "Normal1Paragraph"
                          ? text
                          : Normal1Paragraph}
                      </p>
                      <p
                        onClick={() => {
                          if (text !== Normal2Paragraphs) {
                            setSelectedTemplate("Normal2Paragraphs");
                            setText(Normal2Paragraphs);
                          }
                          if (carouselRef.current) {
                            carouselRef.current.scrollIntoView({
                              behavior: "smooth",
                            });
                          }
                          if (textAreaRef.current) {
                            textAreaRef.current.focus({ preventScroll: true });
                            textAreaRef.current.value = Normal2Paragraphs;

                            const syntheticEvent = {
                              target: textAreaRef.current, // Mimic the textarea's event structure
                            };

                            handleInputChange(
                              syntheticEvent,
                              setText,
                              textAreaRef
                            );
                          }
                          if (currentSlide !== 1) {
                            setCurrentSlide(1);
                          } // Navigate to slide 3
                        }}
                        className={`"p-4 h-24 border-2 rounded-md shadow-md cursor-pointer shadow-primary-light
                          hover:text-primary border-primary overflow-y-auto whitespace-pre-line
                          ${
                            selectedTemplate === "Normal2Paragraphs"
                              ? "text-red-600 p-4"
                              : "bg-white border-primary p-4"
                          }`}
                      >
                        {/* {Normal2Paragraphs} */}
                        {selectedTemplate === "Normal2Paragraphs"
                          ? text
                          : Normal2Paragraphs}
                      </p>
                      <p
                        onClick={() => {
                          if (text !== Poem) {
                            setSelectedTemplate("Poem");
                            setText(Poem);
                          }
                          if (carouselRef.current) {
                            carouselRef.current.scrollIntoView({
                              behavior: "smooth",
                            });
                          }
                          if (textAreaRef.current) {
                            textAreaRef.current.focus({ preventScroll: true });
                            textAreaRef.current.value = Poem;

                            const syntheticEvent = {
                              target: textAreaRef.current, // Mimic the textarea's event structure
                            };

                            handleInputChange(
                              syntheticEvent,
                              setText,
                              textAreaRef
                            );
                          }
                          if (currentSlide !== 1) {
                            setCurrentSlide(1);
                          } // Navigate to slide 3/ Navigate to slide 3
                        }}
                        className={`"p-4 h-24 border-2 rounded-md shadow-md cursor-pointer shadow-primary-light
                          hover:text-primary border-primary overflow-y-auto whitespace-pre-line
                          ${
                            selectedTemplate === "Poem"
                              ? "text-red-600 p-4"
                              : "bg-white border-primary p-4"
                          }`}
                      >
                        {/* {Poem} */}
                        {selectedTemplate === "Poem" ? text : Poem}
                      </p>
                      <p
                        onClick={() => {
                          if (text !== ShortAndSweet) {
                            setSelectedTemplate("ShortAndSweet");
                            setText(ShortAndSweet);
                          }

                          if (carouselRef.current) {
                            carouselRef.current.scrollIntoView({
                              behavior: "smooth",
                            });
                          }
                          if (textAreaRef.current) {
                            textAreaRef.current.focus({ preventScroll: true });
                            textAreaRef.current.value = ShortAndSweet;

                            const syntheticEvent = {
                              target: textAreaRef.current, // Mimic the textarea's event structure
                            };

                            handleInputChange(
                              syntheticEvent,
                              setText,
                              textAreaRef
                            );
                          }
                          if (currentSlide !== 1) {
                            setCurrentSlide(1);
                          } // Navigate to slide 3/ Navigate to slide 3
                        }}
                        className={`"p-4 h-24 border-2 rounded-md shadow-md cursor-pointer shadow-primary-light
                          hover:text-primary border-primary overflow-y-auto whitespace-pre-line
                          ${
                            selectedTemplate === "ShortAndSweet"
                              ? "text-red-600 p-4"
                              : "bg-white border-primary p-4"
                          }`}
                      >
                        {/* {ShortAndSweet} */}
                        {selectedTemplate === "ShortAndSweet"
                          ? text
                          : ShortAndSweet}
                      </p>
                    </div>
                    <button
                      onClick={fetchAIText}
                      className="py-2 mx-2 text-sm border rounded-md md:text-lg border-primary hover:bg-primary-light text-primary flex items-center justify-center gap-2"
                    >
                      <IoReload size={25} />
                      Refresh Messages
                    </button>
                    <div className="flex items-center justify-between mx-2 gap-2">
                      {printLoader ? (
                        <div className="w-full">
                          <Spinner props={""} size={"50px"} />
                        </div>
                      ) : (
                        <button
                          onClick={() => {
                            const result = (customerCards || []).filter(
                              (card) =>
                                card?.status !== "printed" &&
                                card?.status !== "draft"
                            );
                            // Group customer cards by year and month
                            const groupedCards = groupCardsByYearAndMonth(
                              result,
                              occasions
                            );

                            // Find the event object and selected occasion
                            const eventObject = customerCards?.find(
                              (card) => card.eventId === eventId
                            );

                            const selectedOccasion = occasions?.find(
                              (occasion) => occasion._id === eventId
                            );

                            // Adjust event date

                            let adjustedDate;

                            if (eventDate) {
                              adjustedDate = getAdjustedEventDate(
                                eventDate,
                                customerCards.createdAt,
                                selectedOccasion,
                                customerCards
                              );
                            }
                            console.log("eventDate: ", eventDate);
                            const adjustedDateObj = new Date(adjustedDate);

                            // Get current year and month
                            const currentYear = adjustedDate
                              .getFullYear()
                              .toString();
                            console.log(currentYear);
                            const currentMonth =
                              monthOrder[adjustedDateObj.getMonth()];

                            // Check event date and decide action
                            if (eventDate) {
                              const today = moment();
                              const daysDifference = moment(
                                adjustedDateObj
                              ).diff(today, "days");

                              console.log("adjustedDateObj: ", adjustedDateObj);
                              if (daysDifference >= 0 && daysDifference <= 7) {
                                const cardsForCurrentMonth =
                                  groupedCards[currentYear + 1]?.[
                                    currentMonth
                                  ] ?? [];
                                if (cardsForCurrentMonth.length >= 8) {
                                  toast.error(
                                    "You cannot generate more than 8 cards for this month"
                                  );
                                  return;
                                }
                              } else {
                                const cardsForCurrentMonth =
                                  groupedCards[currentYear]?.[currentMonth] ??
                                  [];
                                if (cardsForCurrentMonth.length >= 8) {
                                  toast.error(
                                    "You cannot generate more than 8 cards for this month"
                                  );
                                  return;
                                }
                              }

                              const normalizedEventDate =
                                moment(eventDate).year(2000);
                              const normalizedToday = moment(today).year(2000);

                              if (
                                (normalizedEventDate.isBefore(
                                  normalizedToday
                                ) ||
                                  (daysDifference >= 0 &&
                                    daysDifference < 6)) &&
                                selectedOccasion.name === "Birthday"
                              ) {
                                toggleModal();
                              } else if (
                                normalizedEventDate.isBefore(normalizedToday) ||
                                (daysDifference >= 0 && daysDifference < 6)
                              ) {
                                newToggleModal();
                              } else {
                                handleSubmit("pending");
                              }
                            } else {
                              handleSubmit("pending");
                            }
                          }}
                          className="w-full py-2 text-sm border rounded-md md:text-lg border-primary hover:bg-primary-light text-primary flex items-center justify-center gap-1"
                        >
                          <IoMdPrint size={25} />
                          {fromNavigatedPageName === "SendToPrint"
                            ? "Update in Print"
                            : "Send to Print"}
                        </button>
                      )}

                      {saveLoader ? (
                        <div className="w-full">
                          <Spinner props={""} size={"50px"} />
                        </div>
                      ) : (
                        <button
                          onClick={() => {
                            handleSubmit("draft");
                          }}
                          className="w-full py-2 text-sm border rounded-md md:text-lg border-primary hover:bg-primary-light text-primary flex items-center justify-center gap-1"
                        >
                          <CiBookmarkCheck size={25} />
                          {fromNavigatedPageName === "Draft"
                            ? "Update To Draft"
                            : "Save to Drafts"}
                        </button>
                      )}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <Modal toggleRemoveModal={toggleModal}>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-secondary w-full h-fit p-2 px-4 py-3 rounded-t-xl rounded-tl-xl flex items-center justify-between">
              <h1 className="text-2xl text-white capitalize">
                {/* {occasion} Confirmation */}
                Event Confirmation
              </h1>
              <IoMdClose
                size={30}
                color="white"
                className="cursor-pointer"
                onClick={toggleModal}
              />
            </div>
            <div className="flex flex-col items-center w-[80%] justify-center p-5 m-10 border-2 border-black border-dashed rounded-lg">
              <p className="my-3 text-lg text-center">
                {/* The selected {occasion} is within the next 7 days. It will be
                moved to next year. Do you want to continue? */}
                The selected event is within 7 days. It will be moved to next
                year. Do you want to continue?
              </p>
              <div className="flex items-center justify-center w-full text-xl gap-x-4">
                <button
                  className="flex items-center justify-center px-8 py-2 border-2 rounded-sm border-primary text-primary hover:bg-primary-light gap-x-2"
                  onClick={toggleModal}
                >
                  <IoMdClose size={30} />
                  <span className="font-medium">No</span>
                </button>
                {printLoader ? (
                  <div>
                    <Spinner props={""} size={"50px"} />
                  </div>
                ) : (
                  <button
                    onClick={() => {
                      handleSubmit("pending");
                    }}
                    className="flex items-center justify-center px-8 py-2 text-white border-2 rounded-sm bg-primary hover:bg-primary-dark border-primary gap-x-2"
                  >
                    <IoCheckmark size={30} />
                    <span className="font-medium">Yes</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
      )}

      {isActivityModelOpen && (
        <Modal toggleRemoveModal={newToggleModal}>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-secondary w-full h-fit p-2 px-4 py-3 rounded-t-xl rounded-tl-xl flex items-center justify-between">
              <h1 className="text-2xl text-white capitalize">
                {/* {occasion} Confirmation */}
                Event Confirmation
              </h1>
              <IoMdClose
                size={30}
                color="white"
                className="cursor-pointer"
                onClick={newToggleModal}
              />
            </div>
            <div className="flex flex-col items-center w-[80%] justify-center p-5 m-10 border-2 border-black border-dashed rounded-lg">
              <p className="my-3 text-lg text-center">
                {/* The selected {occasion} is within the next 7 days. It will be
                moved to next year. Do you want to continue? */}
               The selected event is either within 7 days or in the past. So it will be moved to next year. Do you want to continue?
              </p>
              <div className="flex items-center justify-center w-full text-xl gap-x-4">
                <button
                  className="flex items-center justify-center px-8 py-2 border-2 rounded-sm border-primary text-primary hover:bg-primary-light gap-x-2"
                  onClick={newToggleModal}
                >
                  <IoMdClose size={30} />
                  <span className="font-medium">No</span>
                </button>
                {printLoader ? (
                  <div>
                    <Spinner props={""} size={"50px"} />
                  </div>
                ) : (
                  <button
                    onClick={() => {
                      handleSubmit("pending");
                    }}
                    className="flex items-center justify-center px-8 py-2 text-white border-2 rounded-sm bg-primary hover:bg-primary-dark border-primary gap-x-2"
                  >
                    <IoCheckmark size={30} />
                    <span className="font-medium">Yes</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </section>
  );
};

export default PickCard;
